import { Box, Button, TableCell, TableRow, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import AppsIcon from '@mui/icons-material/Apps'
import autoTable from 'jspdf-autotable'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, focusElemnt, navigation3 } from '../../../../common/helper'
import * as id from '../../reportId'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import * as mdt from '../../../../common/modaltypes'
import {filterHeader, filterHeader1 } from './DelFranchiseeConstant'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../common/font/Roboto-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import { divideInNIntegers } from '../../../../common/mathHelper'
import VirtualizedTable from '../../../../common/virtualisedTable'
import { exportToExcel } from '../../../../common/hook'
import { makeTable } from '../../analysisReport/pdfAutotable'


const DetailedReport = ({loginData, isPdfLoading, setIsPdfLoading, disableExcel, updateModal, columnDefs, tableData1, headerFilterData }) => {
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const [tableData, setTableData] = useState([])
    const reportName='Franchisee Deliveries Report'
    useEffect(() => {
        if (tableData1.length > 0) {
            const data = groupedDetailedData(tableData1, columnDefs)
            setTableData(data || [])
        }
    }, [tableData1,columnDefs])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const groupedDetailedData = (arr = [], headers) => {
        const lengths = divideInNIntegers(headers.length, 3);
        let index = 0;
        const pickedHeaders = [];
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index].field);
            index += span;
        });
        const grouped = {};
        const SEPARATOR = "|||";
        arr.forEach((val) => {
            const key = [
                val.PaymentType,
                val.PaymentModeName,
                val.DeliveredByBranch
            ].join(SEPARATOR);

            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(val);
        });

        const transform = (list) =>
            list.map((val, i) => ({
                ...val,
                srNo: i + 1,
                'LRNO^^ManualLRNo': `${val.LRNO}\n${val.ManualLRNo}`,
                DelDate: `${moment(val.DeliveryDate).format("DD-MMM-YY")}\n${moment(val.DeliveryDate).format("HH:mm [Hrs]")}`,
                'SourceCity^^SourceBranch': `${val.SourceCity}\n${val.SourceBranch}`,
                'DispatchedByCity^^DispatchedByBranch': `${val.DispatchedByCity}\n${val.DispatchedByBranch}`,
                'Sender^^SenderMobileNo': `${val.Sender}\n${val.SenderMobileNo}`,
                'SenderGSTN^^SenderEmailID': `${val.SenderGSTN}\n${val.SenderEmailID}`,
                'RecName^^RecMobileNo': `${val.RecName}\n${val.RecMobileNo}`,
                'RecGSTN^^RecEmailID': `${val.RecGSTN}\n${val.RecEmailID}`,
                'DeliveredBy^^ItemDetails': `${val.DeliveredBy}\n${val.ItemDetails}`,
                dataType: 'entry',
            }));
        const summarize = (list) =>
            list.reduce(
                (acc, val) => {
                    acc.Items += +val.Items || 0;
                    acc.Freight += +val.Freight || 0;
                    acc.KMSFreight += +val.KMSFreight || 0;
                    acc.BkgOtherCharges += +val.BkgOtherCharges || 0;
                    acc.DeliveryCartage += +val.DeliveryCartage || 0;
                    acc.DeliveryHamali += +val.DeliveryHamali || 0;
                    acc.ExtraHamali += +val.ExtraHamali || 0;
                    acc.DemurrageChg += +val.DemurrageChg || 0;
                    acc.DeliveryGST += +val.DeliveryGST || 0;
                    acc.DeliveryDiscount += +val.DeliveryDiscount || 0;
                    acc.NetAmount += +val.NetAmount || 0;
                    return acc;
                },
                {
                    Items: 0, Freight: 0, KMSFreight: 0, BkgOtherCharges: 0,
                    DeliveryCartage: 0, DeliveryHamali: 0, ExtraHamali: 0, DemurrageChg: 0,
                    DeliveryGST: 0, DeliveryDiscount: 0, NetAmount: 0
                }
            );
        const finalData = [];
        const grandTotal = {
            Items: 0, Freight: 0, KMSFreight: 0, BkgOtherCharges: 0,
            DeliveryCartage: 0, DeliveryHamali: 0, ExtraHamali: 0, DemurrageChg: 0,
            DeliveryGST: 0, DeliveryDiscount: 0, NetAmount: 0
        };
        Object.entries(grouped).forEach(([key, list]) => {
            const [PaymentType, PaymentModeName, DeliveredByBranch] = key.split(SEPARATOR);

            const transformed = transform(list);
            const summary = summarize(transformed);

            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] += summary[k] || 0;
            });

            finalData.push({
                colSpan: Object.fromEntries(
                    pickedHeaders.map((key, i) => [key, lengths[i] || 1])
                ),
                align: {
                    [pickedHeaders[0]]: "left",
                    [pickedHeaders[1]]: "center",
                    [pickedHeaders[2]]: "right",
                },
                [pickedHeaders[0]]: `Payment Type: ${PaymentType}`,
                [pickedHeaders[1]]: `Payment Mode: ${PaymentModeName}`,
                [pickedHeaders[2]]: `Branch: ${DeliveredByBranch}`,
                dataType: "subHeader",
            });

            finalData.push(...transformed);

            Object.keys(summary).forEach((k) => {
                summary[k] = Number(summary[k].toFixed(2));
            });

            finalData.push({
                ...summary,
                colSpan: {
                    [pickedHeaders[0]]: headers.findIndex(
                        (header) => header.field === "Items"
                    ),
                },
                [pickedHeaders[0]]: `Total: Payment ${PaymentType}, Mode ${PaymentModeName}, Branch ${DeliveredByBranch}`,
                dataType: "total",
                align: { [pickedHeaders[0]]: "right" },
            });
        });

        if (Object.keys(grouped).length > 1) {
            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] = Number(grandTotal[k].toFixed(2));
            });
            const qtyIndex = headers.findIndex(h => h.field === "Items");
            const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
            const firstHeader = headers[0]?.field;
            finalData.push({
                ...grandTotal,
                srNo: `Grand Total:All Payment Types / All Payment Modes / All Branches`,
                dataType: "total",
                colSpan: { [firstHeader]: colSpanCount },
                align: {
                    [firstHeader]: "right",
                    [headers[colSpanCount]]: "right"
                }
            });
        }
        return finalData;
    };
    const filterData = {
        FranchiseCompany: headerFilterData?.FranchiseCompany,
        FranchiseeDelCity: headerFilterData?.FranchiseeDelCity,
        FranchiseeDelBranch: headerFilterData?.FranchiseeDelBranch,
        OwnBookingCity: headerFilterData?.OwnBookingCity,
        dataType: 'entry',
    }
    const filterData1={
        OwnBookingBranch: headerFilterData?.OwnBookingBranch,
        OwnBookingBranchUser: headerFilterData?.OwnBookingBranchUser,
        PaymentType: headerFilterData?.PaymentType,
        PaymentMode: headerFilterData?.PaymentMode,
        ReportView: "Detailed",
        FromDate: headerFilterData?.FromDate,
        ToDate: headerFilterData?.ToDate,
        dataType: 'entry',
    }
    const headers = columnDefs.map((item) => {
        return {
          header: item.header,
          field: item.field,
          headerSx: item.headerSx,
          exportHead: item.exportHead,
          textAlign: item.headerSx?.textAlign || 'left',
        }
      })
      const excelHeaders = headers.flatMap((col) => {
        if (typeof col.field === 'string' && col.field.includes('^^')) {
          const [field1, field2] = col.field.split('^^')
          const [header1, header2] = (col.exportHead || '').split('\n')
          return [
            { field: field1, header: header1, align: col.textAlign },
            { field: field2, header: header2, align: col.textAlign },
          ]
        }
        return { field: col.field, header: col.exportHead, align: col.textAlign }
      })
      const lengths = divideInNIntegers(excelHeaders.length, 3)
      let index = 0
      const pickedHeaders = []
      lengths.forEach((span) => {
        pickedHeaders.push(excelHeaders[index].field)
        index += span
      })
      const excelData = tableData.map((row) => {
        if (row.dataType === 'subHeader') {
          const colSpan = row.colSpan
          const orderedKeys = headers
            .map((c) => c.field)
            .filter((key) => key in colSpan)
            .map((key) => row[key])
          return {
            ...row,
            ...Object.fromEntries(pickedHeaders.map((key, i) => [key, orderedKeys[i]])),
            colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
          }
        }
        if (row.dataType === 'total') {
          return {
            ...row,
            colSpan: { [pickedHeaders[0]]: excelHeaders.findIndex((header) => header.field === 'Items') },
          }
        }
        return row
      })
      const header1 = [
          [{ header: `Report For: ${reportName}`, field: '', span: filterData.length ,mainHeader:true}],
        ]
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        const widthCell = calculateTotalTableWidth(columnDefs)
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
        const doc = new jsPDF({ orientation: columnDefs.length > 12 ? 'l' : 'p', format: columnDefs.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60), unit: 'px', compress: true })

        doc.setProperties({
            title: `Franchisee Deliveries Summary.pdf`,
            subject: 'Franchisee Deliveries Summary Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, LRWise',
            creator: 'MTLPL',
        })
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / (columnDefs.length > 12 ? 1122 : 793);

        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let pdfFilterHeader = filterHeader.map((col) => {
            return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
        })
        let pdfFilterHeader1 = filterHeader1.map((col) => {
            return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
        })
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfFilterHeader,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 225, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didDrawPage: function (data) {
                doc.setTextColor(scaleFactor * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System |  Delivery Reports', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
                doc.text(`Delivery Date: ${filterData1.FromDate} to ${filterData1.ToDate}`, data.settings.margin.left, 150)
                doc.text(`Report: Franchisee Deliveries`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
            showHead: "firstPage",
        })
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfFilterHeader1,
            body: [filterData1],
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,

            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 180, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 160, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 160, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                4: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 150, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            },
            showHead: "firstPage",
        })

        let pdfColumns = columnDefs.map((col) => {
            return { header: col.header, dataKey: col.field, xlCol: col.xlCol }
        })
         makeTable(doc, autoTable, pdfColumns, tableData, 1, 'Delivery Report', loginData, 'everyPage', () => {}, 120, false)
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Franchisee Deliveries Detailed.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            document.getElementById('output').data = doc.output('datauristring', 'Franchisee Deliveries Detailed.pdf')
            focusElemnt('backBtn')
        }, 2000)
    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    const headerContent = () => {
        return (
            <>
                <TableRow>
                    <TableCell
                        className="reportTD"
                        style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#444444',
                            backgroundColor: '#bfe1ff',
                            position: 'sticky',
                            top: '0px',
                            height: '36px',
                            padding: '10px 4px',
                        }}
                        colSpan={headers.length}
                    >
                        {reportName}
                    </TableCell>
                </TableRow>
                <TableRow style={{ height: '47px' }}>
                    {headers.map((item) => {
                        return (
                            <TableCell
                                style={{
                                    ...item?.headerSx,
                                    backgroundColor: '#e5f3ff',
                                    color: '#444',
                                    fontSize: '12px',
                                    lineheight: '16px',
                                    letterspacing: '0.24px',
                                    fontWeight: '600',
                                    whiteSpace: 'pre-line',
                                    padding: '10px 4px',
                                }}
                                colSpan={1}
                            >
                                {item?.header}
                            </TableCell>
                        )
                    })}
                </TableRow>
            </>
        )
    }
    const DeliveryBody = ({ row, index, tableHeaderColor, columnDefs }) => {
        if (!row?.dataType) return null
        const getStyles = (field, align) => {
            const common = {
                minHeight: '36px',
                fontSize: '12px',
                color: '#444',
                padding: '10px 4px',
                whiteSpace: 'pre',
            }
            if (row.dataType === 'entry') {
                return {
                    ...common,
                    fontWeight: '500',
                    textAlign: align || 'left',
                    height: '36px',
                }
            }
            if (row.dataType === 'subHeader') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isSubHeadingColor,
                    textAlign: row.align?.[field] || 'left',
                }
            }
            if (row.dataType === 'total') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isTotalColor,
                    textAlign: row.align?.[field] || 'right',
                }
            }
        }

        return (
            <>
                {(() => {
                    let skip = 0

                    return columnDefs.map((item, i) => {
                        if (skip > 0) {
                            skip--
                            return null
                        }
                        const colSpan = row.colSpan?.[item.field] || 1
                        skip = colSpan - 1
                        return (
                            <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.textAlign)}>
                                {row[item.field]}
                            </TableCell>
                        )
                    })
                })()}
            </>
        )
    }
    const bodyContent = (index, obj) => {
        return <DeliveryBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={headers} />
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', paddingTop: '2px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                        Report For: {reportName}
                    </Typography>
                    <Box
                        sx={{
                            minHeight: '32px',
                            display: 'flex',
                            padding: '8px 12px',
                            justifycontent: 'center',
                            alignitems: 'center',
                            gap: '6px',
                            marginX: '10px',
                            fontSize: '14px'
                        }}
                        id="dispatchReportManageColumn"
                        tabIndex={0}
                        onClick={() => updateModal(true, mdt.LRWiseDetailsReport)}
                    >
                        <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                            <AppsIcon />
                        </span>
                        <span tabIndex={0} style={{ fontWeight: '600' }}>
                            MANAGE COLUMNS
                        </span>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button
                                    variant="outlined"
                                    sx={{ width: '100%' }}
                                    className="receiveitembtn"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        exportToExcel({
                                            fileName: `${reportName} ${currentDateTime}.xlsx`,
                                            sheetName: 'Delivery',
                                            headersList: [header1, filterHeader,filterHeader1, excelHeaders],
                                            dataList: [[], [filterData],[filterData1], excelData],
                                        })
                                    }}
                                    disabled={disableExcel}
                                >
                                    Export to Excel
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"exportPdf"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", disableExcel ? id.reportmainButton : "exportExcelBtn", () => { })
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}
                                >
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={'printBtn'} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, id.selectCompnay, "exportPdf", () => { })
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }}
                                >
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onKeyDown={(e) => {
                                    navigation3(e, id.selectCompnay, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}
                            >
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?
                    <VirtualizedTable
                        tableData={tableData}
                        headerContent={headerContent}
                        rowContent={bodyContent}
                        tableStyle={{ tableLayout: 'auto', width: '100%' }}
                        autoResize={true}
                    />
                : <Box sx={{ ...sx.reportFlex, justifyContent: 'center', height: '55vh' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            title="MTLPL -Cargo System - Franchisee Deliveries Report"
                            aria-label="MTLPL -Cargo System - Franchisee Deliveries Report"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>}
        </>
    )
}

export default DetailedReport